'use strict';

module.exports = '3.28.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 572
// module chunks = 142807904292071